export const htmlString = "<!-- import {ViewModel} from './widget' -->\n<div class=\"@@@\" >\n    <h1 data-bind=\"text:text\"></h1>\n</div>";